import { ErrorHandler, Injectable } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { EventsService } from '../event/event.service';

@Injectable()

export class GlobalErrorHandlerService extends ErrorHandler {
	private is_suppressed = false;
	private error_code;
	private error_message;
	private error_title;
	private error_payload: any;
	private depositLimitMessageShow = true;

	constructor(
		protected readonly eventsService: EventsService,
		public navigator: Navigator
	) {
		super();
	}

	handleError(error: any): GlobalErrorHandlerService {
		this.is_suppressed = false;

		if (error.payload) {
			this.error_payload = error.payload;
		}
		if (error && error.code) {
			switch (error.code) {
				case 'INVALID_SESSION_TOKEN':
					this.is_suppressed = true;
					//this.logoutService.toLogout({code: 'INVALID_SESSION_TOKEN', reason: 'API_INVALID_SESSION_TOKEN'})
					this.eventsService.publish('GlobalErrorHandlerService:action:logout', {
						code: 'INVALID_SESSION_TOKEN',
						reason: 'API_INVALID_SESSION_TOKEN',
					});
					break;
				case 'INVALID_DISCONNECT_TIME_ALLOWED':
					this.is_suppressed = true;
					//this.logoutService.onLogout({code: 'INVALID_DISCONNECT_TIME_ALLOWED', reason: 'INVALID_DISCONNECT_TIME_ALLOWED'})
					this.eventsService.publish('GlobalErrorHandlerService:action:logout', {
						code: 'INVALID_DISCONNECT_TIME_ALLOWED',
						reason: 'INVALID_DISCONNECT_TIME_ALLOWED',
					});
					break;
				case 'REQUEST_VALIDATION_ERROR':
					this.setErrorMessage('Sorry, an error occured. Please try again');
					break;
				case 'GEOLOCATION_PASSTOFAIL':
					this.setErrorMessage(
						'Geolocation from PASS to FAIL: close all games.'
					);
					break;
				case 'INVALID_PARAMETER':
					this.setErrorMessage(
						error.message
					);
					break;
				case 'hasExceededDepositLimit':
					if (!!this.depositLimitMessageShow) {
						this.depositLimitMessageShow = false;
						setTimeout(() => {
							//this.navigator.dismissAll();
						}, 200);
						setTimeout(() => {
							this.navigator.navigateTo("DepositThresholdComponent", { forceModal: true }, { customerId: null, callBackFn: () => this.navigator.toLobby() });
						}, 290);
					}
					break;
				case 'CLOSE_OPENED_GAMES':
					this.setErrorMessage(
						'Close all opened games in order to forfeit the bonus.'
					);
					break;
				case 'CUSTOMER_WRONG_STATUS':
					this.setErrorMessage(
						"Your account is not in 'Active' status. Please contact support."
					);
					break;
				case 'CUSTOMER_SELF_EXCLUDED':
					this.setErrorMessage(
						"Your account is 'Self-Excluded'. Please contact support."
					);
					//this.navigator.toLobby();
					//this.navigator.openPopover("PopoverSelfExcludeComponent","",'standard-popover self-exclude');
					break;
				case 'UNKNOWN_EXCEPTION':
				default:
					this.setErrorMessage(
						'Sorry, an error has occurred. Please try again.'
					);
					break;
			}
			this.setErrorCode(error.code);
		} else {
			console.log('EXCEPTION DETECTED:');
			if (this.error_message) {
				console.error('message: ', this.error_message);
			}
			if (this.error_code) {
				console.error('code: ', this.error_code);
			}
			try {
				console.error(JSON.stringify(error));
			} catch (err) {
				console.error(
					'*************' + error + ', object type: ' + typeof error
				);
			}
		}

		//should at least send some kind of response if the above switch doesnt match any cases
		return this;
	}

	setErrorCode(error_code) {
		this.error_code = error_code;
	}

	getErrorCode() {
		return this.error_code;
	}

	setErrorMessage(error_message) {
		this.error_message = error_message;
	}

	getErrorMessage() {
		return this.error_message;
	}

	setErrorTitle(error_title) {
		this.error_title = error_title;
	}

	getErrorTitle() {
		return this.error_title;
	}

	hasError() {
		return null != this.error_message;
	}

	public getPayload() {
		if (this.error_payload) {
			if (Array.isArray(this.error_payload)) {
				return this.error_payload[0].message;
			}

			if (this.error_payload.message) {
				return this.error_payload.message;
			}

			if (typeof this.error_payload === 'object') {
				return this.error_payload.errors[0].message;
			}

			return this.error_payload;
		}

		return "An error has occurred. Please contact support.";
	}


	isSuppressed() {
		return this.is_suppressed;
	}

	clear() {
		this.error_code = "";
		this.error_message = "";
		this.error_title = "";
	}
}
